import { environment } from '../../../environments/environment.prod';

const baseUrl = environment.baseUrl;
const B2B_URL = environment.b2b_url;
const API_URL = environment.b2c_url;
const proj1 = '/b2b';
const proj2 = '/supervision';

export const airline_url = environment.airline_url + '/airline_logo/';
export const profile_img_url = environment.b2c_url;

/* please maintain Ascending Order of the keys*/
export const apiMap = {
    agentAccountLedger: `${B2B_URL + proj1}/transaction/service/AgentAccountLedger`,
    agentDetails: `${B2B_URL + proj1}/user/service/AgentDetails`,
    addUser: `${API_URL}/webservice/auth/register`,
    bankDetails: `${B2B_URL + proj1}/transaction/service/BankDetails`,
    bankAccountDetails: `${baseUrl + proj2}/cms/service/BankAccountDetails`,
    balanceManager: `${B2B_URL + proj1}/transaction/service/BalanceManager`,
    balanceRequest: `${B2B_URL + proj1}/transaction/service/BalanceRequest`,
    banalanceTransferTypes: `${B2B_URL + proj1}/transaction/service/BanalanceTransferTypes`,
    bookingCalender: `${B2B_URL + proj1}/transaction/service/BookingCalender`,
    bookingDetails: `${B2B_URL + proj1}/transaction/service/BookingDetails`,
    bookingReports: `${B2B_URL + proj1}/flight/service/BookingReports`,
    cabinClass: `${API_URL}/webservice/flight/cabinClassList`,
    changePassword: `${API_URL}/webservice/auth/changePassword`,
    creditLimitManager: `${B2B_URL + proj1}/transaction/service/CreditLimitManager`,
    creditLimitRequest: `${B2B_URL + proj1}/transaction/service/CreditLimitRequest`,
    dailySalesReport: `${B2B_URL + proj1}/flight/service/DailySalesReport`,
    domainLogo: `${baseUrl}/sa/master-data/domain-logo`,
    editProfile: `${B2B_URL + proj1}/user/service/EditProfile`,
    emailVoucher: `${B2B_URL + proj1}/voucher/service/EmailVoucher`,
    extraServices: `${baseUrl}/flight/service/ExtraServices`,
    eventNotfications: `${B2B_URL + proj1}/transaction/service/EventNotfications`,
    fareRule: `${API_URL}/webservice/flight/fareRule`,
    forgotPassword: `${API_URL}/webservice/auth/forgotPassword`,
    latestTransactions: `${B2B_URL + proj1}/transaction/service/LatestTransactions`,
    latestEventNotfications: `${B2B_URL + proj1}/transaction/service/LatestEventNotfications`,
    moduleBookingCount: `${B2B_URL + proj1}/transaction/service/ModuleBookingCount`,
    monthlyRecapReport: `${B2B_URL + proj1}/transaction/service/MonthlyRecapReport`,
    registration: `${B2B_URL + proj1}/user/service/Registration`,
    setBalanceAlert: `${B2B_URL + proj1}/transaction/service/SetBalanceAlert`,
    transactionLogs: `${B2B_URL + proj1}/transaction/service/TransactionLogs`,
    updateBalanceAlert: `${B2B_URL + proj1}/transaction/service/UpdateBalanceAlert`,
    updateDomainLogo: `${B2B_URL + proj1}/user/service/UpdateDomainLogo `,
    updateMarkup: `${B2B_URL + proj1}/voucher/service/UpdateMarkup`,
    //userTitlelist: `${API_URL}/webservice/common/titleList`,
    userLogin: `${API_URL}/webservice/auth/userLogin`,
    commonCitySearch: `${baseUrl}/sa/common/commonCityList`,
    updateProfile: `${B2B_URL + proj1}/user/service/UpdateProfile`,
    userLogout: `${B2B_URL + proj1}/user/service/UserLogout`,
    currencyList: `${baseUrl}/flight/service/CurrencyList`,
    sendItinerary: `${API_URL}/webservice/flight/sendItinerary`,
    fiveStarHotels: `${API_URL}/webservice/hotel/hotel/fiveStarHotels`,
    autocompleteCity: `${API_URL}/webservice/hotel/hotel/autoComplete`,
    hotelDetail: `${API_URL}/webservice/hotel/hotel/hotelDetails`,
    hotelRooms: `${API_URL}/webservice/hotel/hotel/hotelRooms`,
    // countryList: `${baseUrl}/sa/common/countryList`,
    countryList: `${API_URL}/webservice/common/countryList`,
    titleList: `${API_URL}/webservice/hotel/hotel/titleList`,
    addHotelBookingPaxDetails: `${API_URL}/webservice/hotel/hotel/addHotelBookingPaxDetails`,
    nearByHotels: `${API_URL}/webservice/hotel/hotel/nearByHotels`,
    processBooking: `${API_URL}/webservice/hotel/hotel/processBooking`,
    cancelBooking: `${API_URL}/webservice/hotel/hotel/cancelBooking`,
    guestLogin: `${baseUrl}/sa/auth/service/guestLogin`,
    /*Flight Module Webservices */
    flightAutocomplete: `${API_URL}/webservice/flight/autocomplete`,
    flightSearch: `${API_URL}/webservice/flight/search`,
    fareQuote: `${API_URL}/webservice/flight/fareQuote`,
    flightCommitBooking: `${API_URL}/webservice/flight/commitBooking`,
    flightReservation: `${API_URL}/webservice/flight/reservation`,
    flightVoucher: `${API_URL}/webservice/flight/voucher`,
    cancelFlightBooking: `${API_URL}/webservice/flight/cancellation`,
    cancelHotelBooking: `${API_URL}/webservice/hotel/hotel/cancellation`,
    cancelActivityBooking:`${API_URL}/webservice/activity/cancel`,
    airportList: `${API_URL}/webservice/flight/autocomplete`,
    preferredAirlines: `${baseUrl}/sa/flight/flight-service/preferredAirlines`,
    search: `${API_URL}/webservice/flight/search`,
    updateFareQuote: `${API_URL}/webservice/flight/fareQuote`,
    commitBooking: `${API_URL}/webservice/flight/commitBooking`,
    finalBooking: `${API_URL}/webservice/flight/reservation`,
    currencyConversionRate: `${API_URL}/webservice/flight/CurrencyConversionRate`,
    updateLostBaggageProtectionPrice: `${API_URL}/webservice/flight/updateLostBaggageProtectionPrice`,
    pnrRetrieve: `${API_URL}/webservice/flight/pnrRetrieve`,
    flightType: `${API_URL}/webservice/flight/flightType`,
    checkWalletBalance: `${B2B_URL}/b2b/account-system/checkWalletBalance`,
    deductFromWallet: `${B2B_URL}/b2b/account-system/deductFromWallet`,
    searchActivity: `${API_URL}/webservice/activity/search`,
    searchActivityDetails: `${API_URL}/webservice/activity/details`,
    activityAutocompleteCity: `${API_URL}/webservice/activity/autoComplete`,
    activityAvailability: `${API_URL}/webservice/activity/availability`,
    /* Carnect Module*/
    carAutocompleteCity: `${API_URL}/webservice/car/autocomplete`,
    searchCars: `${API_URL}/webservice/car/search`,
    carRateRuleDetails: `${API_URL}/webservice/car/rateRule`,
    carCommitBooking: `${API_URL}/webservice/car/commitBooking`,
    carConfirmBooking: `${API_URL}/webservice/car/booking`,
    carVoucher: `${API_URL}/webservice/car/carVoucher`,
    carCancelBooking: `${API_URL}/webservice/car/cancelBooking`,
    /* User Management*/
    getUserById: `${API_URL}/webservice/user-profile/getUserProfile`,
    updateUser: `${API_URL}/webservice/user-profile/updateProfile`,
    bookingCount: `${API_URL}/webservice/common/bookings/bookingCounts`,
    upcomingBookings: `${API_URL}/webservice/common/bookings/upcomingBookings`,
    myReviews: `${API_URL}/webservice/common/review-rating/reviewRatingsByUser`,
    uploadProfilePic: `${API_URL}/webservice/user-profile/uploadUserProfilePhoto`,
    completedCancelledBookings: `${API_URL}/webservice/common/bookings/completedCancelledBookings`,
    addUserTraveller: `${API_URL}/webservice/user/addUserTraveller`,
    userTravellersList: `${API_URL}/webservice/user/userTravellersList`,
    updateUserTraveller: `${API_URL}/webservice/user/updateUserTraveller`,
    deleteUserTraveller: `${API_URL}/webservice/user/deleteUserTraveller`,
    addCorePaymentDetails: `${API_URL}/webservice/core/core-payment-details/addCorePaymentDetails`,
    corePaymentDetailsList: `${API_URL}/webservice/core/core-payment-details/corePaymentDetailsList`,
    deleteCorePaymentDetailsList: `${API_URL}/webservice/core/core-payment-details/deleteCorePaymentDetails`,
    addReviewRatings: `${API_URL}/webservice/common/review-rating/addReviewRatings`,
    reviewRatings: `${API_URL}/webservice/common/review-rating/reviewRatings`,
    updateReviewRatings: `${API_URL}/webservice/common/review-rating/updateReviewRatings`,
    addReviewImages: `${API_URL}/webservice/common/review-rating/addReviewImages`,
    domainInformationList: `${API_URL}/webservice/core/core-domain/domainInformationList`,
    homeAutoCompleteCity: `${API_URL}/webservice/common/autoComplete`,
    addEmailSubscription: `${API_URL}/webservice/core/email-subscriptions/addEmailSubscription`,
    phoneCodeList: `${API_URL}/webservice/common/phoneCodeList`,
    userTitlelist: `${API_URL}/webservice/common/titleList`,
    getCurrencySymbols: `${baseUrl}/sa/cms/service/getCurrencySymbols`,
    mainBannerImagesList: `${API_URL}/webservice/common/mainBannerImagesList`,
    staticPageContentList: `${API_URL}/webservice/core/core-staticPageContent/staticPageContentList`,
    listPromocode: `${API_URL}/webservice/common/listPromocode`,
    searchByBookindId: `${API_URL}/webservice/common/bookings/searchByBookindId`,
    // Hotel Module
    cityList: `${API_URL}/webservice/hotel/hotel/autoCompleteSmyrooms`,
    searchHotel: `${API_URL}/webservice/hotel/hotel/searchHotels`,
    hotelDetails: `${API_URL}/webservice/hotel/hotel/hotelDetails`,
    blockRoom: `${API_URL}/webservice/hotel/hotel/blockRooms`,
    addPaxDetails: `${API_URL}/webservice/hotel/hotel/addPaxDetails`,
    reservation: `${API_URL}/webservice/hotel/hotel/reservation`,
    hotelVoucher: `${API_URL}/webservice/hotel/hotel/voucher`,
    b2bHotelVouher: `${B2B_URL}/b2b/hotel/service/hotelVoucher`,
    paymentConfirmation: `${B2B_URL}/b2b/flight/service/paymentConfirmation`,
    hotelPaymentConfirmation: `${B2B_URL}/b2b/hotel/service/paymentConfirmation`,
    servicePurchase: `${B2B_URL}/b2b/baggageInsurance/servicePurchase`,
    listFlightTopDestination: `${API_URL}/webservice/flight/listFlightTopDestination`,
    ManageDomain: `${B2B_URL}/b2b/common/ManageDomain`,
    executePayment: `${B2B_URL}/b2b/paymentGateway/executePayment`,
    executePayment_local: `http://localhost:4008/b2b/paymentGateway/executePayment`,
    b2bFlightVoucher: `${B2B_URL}/b2b/flight/service/flightVoucher`,
    completeBooking: `${API_URL}/webservice/hotel/hotel/completeBooking`,
    completeBooking_dev: `http://localhost:4005/webservice/hotel/hotel/completeBooking`,
    updatePassword: `${API_URL}/webservice/auth/updatePassword`,
    resetPassword: `${B2B_URL}/b2b/user/service/resetPassword`,
    resetPasswordB2C: `${API_URL}/webservice/auth/updatePassword`,
    addRecentSearch: `${API_URL}/webservice/hotel/hotel/addRecentSearch`,
    getRecentSearch: `${API_URL}/webservice/hotel/hotel/getRecentSearch`,
    deleteHotelRecentSearch: `${API_URL}/webservice/hotel/hotel/deleteRecentSearch`,
    addCarRecentSearch: `${API_URL}/webservice/car/addRecentSearch`,
    getCarRecentSearch: `${API_URL}/webservice/car/getRecentSearch`,
    deleteCarRecentSearch: `${API_URL}/webservice/car/deleteRecentSearch`,
    addFlightRecentSearch: `${API_URL}/webservice/flight/addRecentSearch`,
    getFlightRecentSearch: `${API_URL}/webservice/flight/getRecentSearch`,
    deleteFlightRecentSearch: `${API_URL}/webservice/flight/deleteRecentSearch`,
    getActivityRecentSearch: `${API_URL}/webservice/activity/getRecentSearch`,
    addActivityRecentSearch: `${API_URL}/webservice/activity/addRecentSearch`,
    deleteActivityRecentSearch: `${API_URL}/webservice/activity/deleteRecentSearch`,
    currentMonthRecordList: `${API_URL}/webservice/common/currentMonthRecordList`,
    getConfirmedAndCancelledBookings: `${API_URL}/webservice/common/bookings/getConfirmedAndCancelledBookings`,
    getHotelBookingDetails: `${API_URL}/webservice/common/bookings/getHotelBookingDetails`,
    getFlightBookingDetails: `${API_URL}/webservice/common/bookings/getFlightBookingDetails`,
    reservationResponse: `${API_URL}/webservice/flight/reservationResponse`,
    createAppReference: `${API_URL}/webservice/common/createAppReference`,
    updatePassengerDetails: `${API_URL}/webservice/flight/updatePassengerDetails`,
    baggageproductList: `${B2B_URL}/b2b/baggageInsurance/productList`,
    sslTransactionInit: `${B2B_URL}/b2b/paymentGateway/sslTransactionInit`,
    getPaymentGateWays: `${API_URL}/webservice/paymentGateway/getPaymentGateWays`,
    currencyConverison: `${baseUrl}/sa/cms/service/CurrencyConversion`,
    flightSeatAvailability: `${API_URL}/webservice/flight/seatAvailability`,
    // autocomplete: `${baseUrl + portProj4 + proj4}/hotel/static/autocomplete`,
    // searchHotel: `${API_URL}/webservice/hotel/hotel/searchHotel`,
    // blockRoom: `${API_URL}/webservice/hotel/hotel/blockRoom`,
    // baggageproductList: `${B2B_URL}/b2b/baggageInsurance/productList`,
    // editUser: `${baseUrl + proj3}/user/service/updateUser`,
    // searchByBookindId: `${B2B_URL}/b2b/common/bookings/searchByBookindId`,
    // forgotPassword: `${B2B_URL}/b2b/user/service/forgotPassword`,

    //tour api
    tourAutocompleteCity: `${API_URL}/webservice/tour/autoComplete`,
    searchTour: `${API_URL}/webservice/tour/search`,
    tourDetail: `${API_URL}/webservice/tour/tourDetail`,
    createAppRef: `${API_URL}/webservice/common/createAppReference`,
    tourAddPax: `${API_URL}/webservice/tour/addPaxDetails`,
    tourConfirm: `${API_URL}/webservice/tour/confirmBooking`,
    tourVoucher: `${API_URL}/webservice/tour/Voucher`,

    // tourAutocompleteCity: `https://booking247.com:4015/webservice/tour/autoComplete`,
    // searchTour: `https://booking247.com:4015/webservice/tour/search`,
    // tourDetail: `https://booking247.com:4015/webservice/tour/tourDetail`,
    homeTourData: `${baseUrl}/sa/tour/tours/toursList`,
    tourValuation: `${API_URL}/webservice/tour/tourValuation`,
    sendEnquiry: `${API_URL}/webservice/tour/sendEnquiry`,
    tourCountryList: `${API_URL}/webservice/tour/countryList`,

    //home dyanamic api
    listHotelTopDestination: `${API_URL}/webservice/hotel/hotel/listHotelTopDestinations`,
    whyChooseUs:`${baseUrl}/sa/common/whyChooseusDatalist`,

    //activity api
    availability:`${API_URL}/webservice/activity/search`,
    activityCityList: `${API_URL}/webservice/activity/cityList`,
    activityTripList: `${API_URL}/webservice/activity/tripList`,
    activityProductDetails: `${API_URL}/webservice/activity/ProductDetails`,
    activityBlockTrip: `${API_URL}/webservice/activity/blocktrip`,
    activityAddPax: `${API_URL}/webservice/activity/addPax`,
    activityConfirm: `${API_URL}/webservice/activity/confirmBooking`,
    activityVoucher: `${API_URL}/webservice/activity/voucher`,

    //Transfer api's
    transferCityList: `${API_URL}/webservice/transfer/cityList`,
    transferSearch: `${API_URL}/webservice/transfer/availability`,
    productDetails: `${API_URL}/webservice/transfer/productDetails`,
    tripList: `${API_URL}/webservice/transfer/tripList`,
    blocktrip: `${API_URL}/webservice/transfer/blocktrip`,
    transferAddPax: `${API_URL}/webservice/transfer/addPax`,
    transferConfirm: `${API_URL}/webservice/transfer/confirmBooking`,
    transferVoucher: `${API_URL}/webservice/transfer/voucher`,
    transferCancel: `${API_URL}/webservice/transfer/cancelBooking`,
    getPromoCodeInfo:`${API_URL}/webservice/common/getPromoCodeInfo`,

    //supplier
    hotelTypeList: `${baseUrl}/hotel/hotel-types/hotelTypeList`,
    getCity:`${baseUrl}/common/city/findAll`,
    addSupplier:`${API_URL}/webservice/supplier/create`,
    mealList:`${API_URL}/webservice/common/meals/findAll`,
    weekList:`${API_URL}/webservice/common/weekend/findAll`,
    viewList:`${API_URL}/webservice/common/views/findAll`,
    supplierCountryList:`${API_URL}/webservice/common/country/findAll`,
    supplierCityList:`${API_URL}/webservice/common/city/findAll`,
    hotelType:`${API_URL}/webservice/common/hotelType/findAll`,
    commonCityList: `${baseUrl}/sa/common/city/findAllCities`,
    //contact Us
    AddContactList:`${API_URL}/webservice/common/AddContactList`,

//OTP
generateOTP:`${API_URL}/webservice/common/generateOTP`,
validateOTP:`${API_URL}/webservice/common/validateOTP`,

//login
validateOTPLogin:`${API_URL}/webservice/auth/verifyOtp`,
//FAQ
ListFaq:`${API_URL}/webservice/common/ListFaq`,
customerListFaq:`${API_URL}/webservice/common/ListCustomerFaq`,

//homepage
adminManageDomain:`${baseUrl}/sa/cms/service/ManageDomain`,

tourPackageDetail: `${baseUrl}/sa/tour/PackageMasterList/PackageMasterList`,
getPackageIncludeList: `${baseUrl}/sa/tour/includes_master/IncludeMasterList`,
initiatePayment: `${B2B_URL}/b2b/paymentGateway/barclayardTransactionInit`,
paymentConfirm: `${B2B_URL}/b2b/paymentGateway/barclayardTransactionStatus`,


//cart
addBundleBooking: `${API_URL}/webservice/bundle-booking/addBundleBooking`,
getBundleBooking : `${API_URL}/webservice/bundle-booking/getBundleBooking`,
removeBundleBooking: `${API_URL}/webservice/bundle-booking/removeBundleBooking`,
commitBundleBooking: `${API_URL}/webservice/bundle-booking/addPaxDetails`,
finalBundleBooking: `${API_URL}/webservice/bundle-booking/reservation`,
bundleVoucher: `${API_URL}/webservice/bundle-booking/bundleVoucher`,
cartSearchInfo:`${API_URL}/webservice/common/searchInfo`,

familyHotels:`${API_URL}/webservice/hotel/hotel/familyHotels`,
homePageTourType:`${API_URL}/webservice/tour/homePageTourType`,
flightAdList:`${API_URL}/webservice/flight/flightAdList`,
sendHotelEnquiry:`${API_URL}/webservice/hotel/hotel/sendEnquiry`,
socialLink: `${baseUrl}/sa/core/core-manage-social-links/listManageSocialLink`,

flightsSlides: `${API_URL}/webservice/flight/flightPartnerList`,
registerCity: `${B2B_URL}/b2b/common/getCityLists`,
registerState: `${B2B_URL}/b2b/common/getStatesLists`,

generateToken: `${API_URL}/webservice/hotel/hotel/generateToken`,
getTokenData: `${API_URL}/webservice/hotel/hotel/getTokenData/`,
getHotelDetails: `${API_URL}/webservice/hotel/hotel/getHotelDetails/`,

generateFlightToken: `${API_URL}/webservice/flight/generateToken`,
getFlightTokenData: `${API_URL}/webservice/flight/getTokenData/`,

generateActivityToken: `${API_URL}/webservice/activity/generateToken`,
getActivityTokenData: `${API_URL}/webservice/activity/getTokenData/`,

generateTransferToken: `${API_URL}/webservice/transfer/generateToken`,
getTransferTokenData: `${API_URL}/webservice/transfer/getTokenData/`,

generateTourToken: `${API_URL}/webservice/tour/generateToken`,
getTokenTourData: `${API_URL}/webservice/tour/getTokenData/`,

};
